import React from 'react';

export const Close: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="7 7 10 10" {...props}>
    <path
      d="M16 8.47l-3.53 3.529L16 15.53l-.47.469L12 12.47l-3.53 3.529L8 15.53l3.53-3.531L8 8.47l.47-.471L12 11.53l3.53-3.531z"
      fill="currentColor"
    />
  </svg>
);
